import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectTotalHomeCount = (state: RootState) =>
    state?.results?.totalHomeCount;
